import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { Subject, forkJoin,filter, debounceTime, takeUntil } from 'rxjs';
import { BillingStatus, UserPermission } from 'src/app/enums/enums';
import { FilterPipe } from 'src/app/pipes/list-filter-pipe/list-filter-pipe';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { CsvService } from 'src/app/services/csv-service/csv.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert, sweetAlertWithHtml } from 'src/app/utils/swal';
import { getSkippedItemsHtml } from 'src/app/utils/skipped-alert.utils';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.css']
})


export class BillingListComponent {
isTripDetailModal: boolean = false;
  selectedTrips: any = [];
  tripId: any;
  search: any;
  trips: any = [];
  fundingSources:any;
  spacetypes: any;
  preSpacetypes: any = {};
  preServiceAreas: any = {};
  // preMembers: any = {};
  preAppointmentType: any = {};
  preCompanies: any = {};
  preLevelOfService:any = {};
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  selectedStatus: any = '';
  payModalObj: any;
  payRelation: any;
  bulkPayIds: string[] = [];
  selectedPaymentStatus: any = '';
  selectedPaymentType: any = '';
  todayDate:any = [];
  startDate:any;
  endDate:any;
  levelofservices:any;
  selectedCompany = '';
  companies:any;
  serviceAreas : any;
  selectedServiceArea:any = ''
  selectedSpaceType:any = ''
  memberNotesObj:any;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  isDropdownOpen = false;
  user:any;
  preFundingSource:any = {};
  timeZone:any = timeZone;
  currentDate:any = moment().tz(this.timeZone).toISOString()
  userPermission=UserPermission;
  filterdataList:any= [];
  members:any = [];
  selectedMembers: any = null;
  memberSearchQuery: any;
  private readonly memberSearchSubject = new Subject<string | undefined>();
  memberPageNumber = 1;
  memberSearchPageNumber = 1;
  private searchSubject = new Subject<string>();
  drivers:any = [];
  preDrivers:any = {};
  vehicles:any = [];
  preVehicles:any = {};
   paramountLoader = {
    isModal: false,
    isLoading: false
  };
  
  selectedCorporateUser:any = ''
  selectedCorporateObj:any
  preSpaceTypes = {};
  dataList = [];
  selectedFundingSource: any = '';
  tripTrailId: any;
  rejectReasonModalObj: any;
  billingStatus = BillingStatus;

  onway: any;
  arrived: any;
  inProgress: any;
  completed: any;
  signatureModalObj: any;
  logObj:any;


  constructor(
    private sharedDataService: SharedDataService,
    private serviceArea : ServiceAreasService,
    private credentialService : CredentialService,
    private levelOfService : LosService,
    private appointmentService: AppointmentTypeService,
    // private memberService: MemberService,
    private spaceTypeService: SpaceTypeService,
    private billingService: BillingService,
    private router: Router,
    private csvService: CsvService,
    private fundingSourceService: FundingSourceService,
    public permissionService: PermissionService,
    private memberService: MemberService,
    private fundingSource: FundingSourceService
  ) {

  }

  ngOnInit(): void {
    this.getUser();
    this.getFundingSources() 
     this.getAllMembers();
     this.getDrivers();
     this.getFleet();
    this.listenMemberSearch();
    this.initializeSearch();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        this.loadInitialData();
      }

    })
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: 'true'
    }
    forkJoin({
      companies: this.credentialService.getPicker(queryparams),
      levelOfService: this.levelOfService.getPicker(queryparams),
      appointments: this.appointmentService.getPicker(queryparams),
      // members: this.memberService.getPickerMembers(queryparams),
      spaceTypes: this.spaceTypeService.getPicker(queryparams),
      serviceAreas: this.serviceArea.getPicker(queryparams)
    }).pipe(untilDestroyed(this))
      .subscribe(({ companies, levelOfService, appointments, members, spaceTypes, serviceAreas }: any) => {

        //  Companies
        if (companies?.results?.length) {
          this.companies = companies.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Appointments
        if (appointments?.results?.length) {
          this.preAppointmentType = appointments.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Members
        // if (members?.results?.length) {
        //   this.preMembers = members.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        // }

        //  Space Types
        if (spaceTypes?.results?.length) {
          this.spacetypes = spaceTypes.results;
          this.preSpacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  serviceAreas
        if (serviceAreas?.results?.length) {
          this.serviceAreas = serviceAreas.results
          this.preServiceAreas = serviceAreas.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Trips 
        this.getAllTrips(this.currentPage);
      });
  }

  
  

 getAllTrips(page: any) {
  this.clear();
  let queryparams: any = {
    limit: 50,
    page,
    status: ['completed','cancelled'],
    time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    company: this.selectedCompany || undefined,
    sortBy: 'member:asc',
  };

  if (!this.selectedCompany) {
      delete queryparams.company;
    }

  if (this.selectedCorporateUser) {
    queryparams.fundingsource = this.selectedCorporateUser;
  }
   
  if (this.selectedServiceArea) {
      queryparams.serviceArea = this.selectedServiceArea;
    }
     if (this.selectedMembers) {
      queryparams.member = this.selectedMembers;
    }
     if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }

    if (this.selectedPaymentStatus) {
      queryparams.payment = this.selectedPaymentStatus;
    }

    if (this.selectedPaymentType) {
      queryparams.paymentType = this.selectedPaymentType;
    }

  this.billingService.getBillingTrips(queryparams)
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data && data.results) {
        this.trips = data.results.map((trip:any) => ({
          ...trip,
          onway: trip.events?.find((e:any) => e.status === 'onway'),
          arrived: trip.events?.find((e: any) => e.status === 'arrived'),
          inProgress: trip.events?.find((e: any) => e.status === 'in_progress'),
          completed: trip.events?.find((e: any) => e.status === 'completed')
        }));
        this.filterdataList = this.trips;
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    });
}

onFundingSourceChange() {
  this.selectedCorporateObj = this.preFundingSource[this.selectedCorporateUser];
  this.getAllTrips(this.currentPage);
}


  onSelectTrip(trip: any) {
    const index = this.selectedTrips.findIndex((t: any) => t.id === trip.id); // Check if trip is already selected
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip);
    }
    this.isDropdownOpen = this.selectedTrips.length > 0;
  }

 onSelectAllTrips(event: any) {
  const checked = event.target.checked;
  this.filterdataList.forEach((trip: any) => trip.isSelected = checked);
  this.selectedTrips = checked ? [...this.filterdataList] : [];
  this.isDropdownOpen = checked;
}

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(page);
  }

  opendetailModal(trip: any) {
    this.tripId = trip.id;
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.getAllTrips(this.currentPage);
  }

  filterTrips(status?: string) {
    this.selectedStatus = status || '';
    this.getAllTrips(this.currentPage);
  }

  clear(){
    this.trips = []
    this.selectedTrips = []
    // this.trip.isSelected = false;
  }

  onCompanyChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
  }

  openBulkPayModal() {
    this.bulkPayIds = this.selectedTrips.map((trip: any) => trip.id);
    this.isDropdownOpen = false;
  }

  onCloseBulkPayModal(data: any) {
    this.bulkPayIds = [];
    if (!data) return;
    this.getAllTrips(this.currentPage);
    if (data.skippedPayments?.length) {
      sweetAlertWithHtml('Alert', '', 'alert', 'OK', getSkippedItemsHtml(data.skippedPayments, `Batch ${data.batchId}: ${data.createdPayments.length} paid, ${data.skippedPayments.length} skipped.`));
    } else {
      sweetAlert('Success', `Batch ${data.batchId}: ${data.createdPayments.length} payment(s) added`, 'success', 'OK');
    }
  }

  openPayModal(trip: any) {
    this.payModalObj = trip;
    this.payRelation = { relationType: 'vendor', company: trip.company, billing: trip.id, trip: trip.trip };
  }

  onClosePayModal(evt: any) {
    this.payModalObj = null;
    this.payRelation = null;
    if (evt) {
      // the billing is now settled - pull the refreshed payment state
      this.getAllTrips(this.currentPage);
    }
  }

  onPaymentStatusChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onPaymentTypeChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onServiceAreaChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
  }
 
  onSpaceTypeChange(){
    this.getAllTrips(this.currentPage);
  }

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }

  showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

   closeFilterDropDown(evt:any) {
    this.isDropdownOpen = false
  }

  //  closeMenu(evt:any) {
  //   this.isDropdownOpen = false;
  // }

  editTrip(evt:any){
    this.router.navigateByUrl(`trips/${evt.id}/edit`)
  }
  toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }


  getAllMembers() {
    const queryParams: any = {
      limit: 10,
      page: this.memberPageNumber,
      isActive: true,

    }
    this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.members = [...this.members, ...data.results];
        this.memberPageNumber += 1;
      }
    })
  }

  onMembersChange(evt:any){
    this.selectedMembers = evt;
     this.getAllTrips(this.currentPage = 1);
  }

  getFundingSources() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSourceService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
          this.preFundingSource = this.fundingSources.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getDrivers() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.credentialService
      .getPickerDrivers(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.drivers = data.results;
          this.preDrivers = this.drivers.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getFleet() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.credentialService
      .getPickerVehicles(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.vehicles = data.results;
          this.preVehicles = this.vehicles.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getSelectedTrips() {
    return this.trips
      .filter((trip: any) => trip.isSelected);
  }

  tripDetailFile() {
    let selectedTrip;
    if (!this.selectedTrips.length)
      selectedTrip = this.trips;
    else
      selectedTrip = this.getSelectedTrips();

    this.csvService.generateTripItineraryReport(selectedTrip, this.todayDate, this.timeZone, this.preLevelOfService, this.preSpacetypes, this.preServiceAreas, this.preFundingSource)
  }

  ngOnDestroy(): void {
  }

  hasUnpaidSelectedTrips() {
    return (this.selectedTrips || []).some((trip: any) => trip.payment?.status !== 'paid');
  }

  generateBills() {
    const payload = {
      selectedIds: (this.selectedTrips || [])
        .filter((trip: any) => trip.payment?.status !== 'paid')
        .map((trip: any) => trip.id)
    };
    this.billingService.generateVendorBills(payload).subscribe({
      next: (data: any) => {
        this.isDropdownOpen = false;
        this.getAllTrips(this.currentPage);
        if (data.skippedBills?.length) {
          const message = `Some bills (${data.skippedBills.length}) were skipped.`;
          sweetAlertWithHtml('Alert', 'This is a sample message', 'alert', 'OK', getSkippedItemsHtml(data.skippedBills, message));
        } else {
          sweetAlert('Success', 'The bills of selected billings have been generated', 'success', 'OK');
        }
      },
      error: (err: any) => {
        this.isDropdownOpen = false;
        sweetAlert('Error', err, 'error', 'OK');
      }
    });
  }

  uncheckTrips() {
    this.trips.forEach((trip: any) => trip.isSelected = false);
  }

  openAdjustTrip(event:any){
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/billing/vendor/${event.id}/adjustTrip`])
    );
    window.open(url, "_blank");
  }


  onScroll() {
    if (this.memberSearchQuery) {
      this.memberSearch(this.memberSearchQuery);
    } else {
      this.getAllMembers();
    }
  }

   onSearch(event: any) {
      const { term } = event;
      if (term) {
        this.memberSearchSubject.next(term);
      } else {
        this.clearSearh();
      }
    }

  clearSearh() {
    this.memberSearchQuery = '';
    this.memberSearchPageNumber = 1;
    this.members = [];
    this.memberPageNumber = 1
    this.getAllMembers();
  }

  
    listenMemberSearch() {
      this.memberSearchSubject
        .pipe(debounceTime(1000))
        .pipe(untilDestroyed(this)).subscribe((search) => {
          this.memberSearchQuery = search;
          if (search && search.length >= 3) {
            this.members = [];
            this.memberSearchPageNumber = 1;
            this.memberSearch(search);
          }
        });
    }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      )
      .subscribe(() => {
        this.currentPage = 1;
        this.getAllTrips(this.currentPage);
      });
  }


  onSearchInput() {
    this.searchSubject.next(this.search);
  }
  
    memberSearch(search: any, id = null) {
      const queryParams: any = {
        limit: 10,
        page: this.memberSearchPageNumber
      }
  
      if (search) {
        queryParams.search = search;
      }
  
      if (id) {
        queryParams.id = id;
      }
  
      if (!this.tripId) {
        queryParams.isActive = true;
      }
  
      this.memberService.searchMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.members = [...this.members, ...data.results];
          this.memberSearchPageNumber += 1;
        }
      });
    }
  onClear() {
    if (this.memberSearchQuery) {
      this.clearSearh();
      this.clearMemberData();
    }
  }

  clearMemberData() {
    this.selectedMembers = null;
  }

  downloadRawReport() {
    let queryparams:any = {
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    }
    if(this.selectedTrips && this.selectedTrips.length){
      queryparams.selectedIds = this.selectedTrips.map((trip: any) => trip.id);
    }
    this.billingService.getReportTrips(queryparams)
      .subscribe((trips:any) => {
        if (trips && trips.length) {

          this.filterRawReportTrips(trips);
        }
      });
  }

  openParamountModal() {
  this.selectedTrips = this.filterdataList.filter((trip: any) => trip.isSelected);
  if (this.selectedTrips.length) {
    this.selectedTrips.splice(0, this.selectedTrips.length, ...this.selectedTrips);
    this.paramountLoader.isModal = true;
  }
}



  filterRawReportTrips(trips:any) {

    this.csvService.generateRawTripReport(
      trips,
      this.todayDate,
      this.timeZone,
      'vendorBilling'
    );
  }


  onClose() {
    if (!this.selectedMembers && this.memberSearchQuery) {
      this.clearSearh();
    }
  }

  openTripTrails(trip: any) {
    this.tripTrailId = trip.id;
  }

  acceptTrip(trip?: any) {
    let selectedIds = [];
    sweetAlert(
      "Alert",
      "Are you sure you want to accept the selected trip(s)?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (trip) {
          selectedIds = [trip.id];
        } else {
          selectedIds = this.selectedTrips
          // .filter((trip: any) => !(trip.billingStatus === BillingStatus.ACCEPTED))
          .map((trip: any) => trip.id)
        }
        if (selectedIds && selectedIds.length) {
          this.acceptRequest(selectedIds);
        }
      }
    });
  }

  acceptRequest(selectedIds: any) {
    const payload: any = {
      status: BillingStatus.ACCEPTED,
      selectedIds: selectedIds,
      billingRejectReason: ''
    }

    this.billingService
      .updateBillingStatus(payload)
      .subscribe(data => {
        if (data) {
          this.trips.forEach((trip: any) => {
            if (selectedIds.includes(trip.id)) {
              trip.billingStatus = BillingStatus.ACCEPTED;
              trip.billingRejectReason = '';
            }
          });
        }
      });
  }

  rejectTrip(trip?: any) {
    const selectedIds = trip ? [trip.id] : this.selectedTrips
      // .filter((trip: any) => !(trip.billingStatus === BillingStatus.ACCEPTED))
      .map((trip: any) => trip.id);

    if (selectedIds && selectedIds.length) {
      this.rejectReasonModalObj = selectedIds;
    }
  }

  onRejectBillingTrip(evt: any) {
    if (evt) {
      const {reason, selectedIds} = evt;
      this.trips.forEach((trip: any) => {
        if (selectedIds.includes(trip.id)) {
          trip.billingStatus = BillingStatus.REJECTED
          trip.billingRejectReason = reason;
        }
      });
    }
    this.rejectReasonModalObj = null;
  }

  isAllTripsAccepted() {
    let bln = false;
    if (this.selectedTrips && this.selectedTrips.length) {
      bln = this.selectedTrips.every((trip: any) => trip.billingStatus === BillingStatus.ACCEPTED);
    }
    return bln;
  }

  openSignatureModal(trip: any) {
    this.signatureModalObj = trip;
  }

  onCloseSignatureModal(evt: any) {
    if (evt) {
      this.signatureModalObj.signature = evt.signature;
    }
    this.signatureModalObj = null;
  }

  openLogModal(trip: any) {
    this.logObj = trip.id;
  }
}
